// PKGV.D4 (#804) — "Knowledge Graph Health" settings page.
//
// TENANT_ADMIN only, matching every other dedicated settings sub-page
// (SettingsPlatformAccessLogPage.tsx, SettingsTenantBrandingPage.tsx) — the
// SettingsPage.tsx card links here rather than rendering charts inline
// (Sprint-D4-adjudication.md Q1).

import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useMyTenant, isAdminRole } from '../hooks/useMyTenant';
import ExecPKGSummary from '../components/pkg/ExecPKGSummary';

export default function SettingsPkgHealthPage() {
  const { myTenant, loading: tenantLoading } = useMyTenant();
  const isAdmin = isAdminRole(myTenant?.role);

  if (tenantLoading) {
    return (
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <main style={{ padding: 24 }}>Loading…</main>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <main style={{ padding: 24, maxWidth: 600 }}>
          <h1 style={{ fontSize: 24, marginBottom: 12 }}>Knowledge Graph Health</h1>
          <p style={{ color: '#6b7280' }}>
            This page is only visible to tenant administrators.
            <Link to="/settings" style={{ marginLeft: 8 }}>← Back to Settings</Link>
          </p>
        </main>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <main style={{ padding: 24, maxWidth: 1100 }}>
        <Link to="/settings" style={{ color: '#6b7280', fontSize: 14 }}>← Back to Settings</Link>
        <h1 style={{ fontSize: 28, margin: '12px 0 4px' }}>Knowledge Graph Health</h1>
        <p style={{ color: '#4b5563', maxWidth: 720, lineHeight: 1.5, marginBottom: 24 }}>
          An aggregated view of your organisation&apos;s knowledge graph health across all projects — edge
          density, governance gaps, and enrichment usage — without navigating individual project graphs.
        </p>
        <ExecPKGSummary />
      </main>
    </div>
  );
}
